/**
 * @file location-page
 * @author
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Pagination from 'antd/lib/pagination';
import Spin from 'antd/lib/spin';
import Modal from 'antd/lib/modal';
import CompLocationPicker from './comp/CompLocationPicker';

import CompAreaItem from './comp/CompAreaItem';
import CompMoreService from './comp/CompMoreService';
import {getUrlValue, bCat_2055_request, recordProxy} from '../../util';
import {
    ExclamationCircleFilled
} from '@ant-design/icons';
import {
    setUserPosition,
    getAreaData,
    getLocationResult,
    setUserPoint
} from '../../actions/locationPage';
import {fetchUserInfo} from '../../actions/attestAction';
import {IState, IProps, IAreaParam, AreaType, areaParams, IPosition, IAreaDict} from './locationResInterface';
import './index.less';
export class LocationResult extends React.Component<IProps, IState>{
    constructor(props: IProps) {
        super(props);
        const search = decodeURIComponent(getUrlValue('search')); // 卡片title
        const tag = this.getRealTag();
        const srcid = decodeURIComponent(getUrlValue('srcid'));
        const cardProvince = decodeURIComponent(getUrlValue('prov'));
        const cardCity = decodeURIComponent(getUrlValue('city'));
        const cardDistrict = decodeURIComponent(getUrlValue('district'));
        // const word = getUrlValue('word'); // 只有从卡片标题点击过来才有这个参数,卡片query
        this.state = {
            locArr: [],
            routerSearch: search, // 传给后端参数，如果切换当前地域，需要置空
            cardTitle: search,
            organList: [],
            organCount: 0,
            page: 1,
            pageSize: this.getTitleStatus() ? 50 : 10,
            isLoc: '1', // 是否输出定位地域信息 1：输出 省，市，区/县, 0：不输出
            tag,
            isFirstSwitchToast: true,
            srcid,
            isTitleSrc: this.getTitleStatus(), // true: 核酸检测卡片标题点击进入
            loading: false,
            coordtype: 'wgs84',  // 经纬度数据类型：默认gcj01,百度地图：bd09
            pageShowTitle: '',
            pageShowText: '',
            isNoRegionType: '0', // 当前页面是否是无地域类型 '1':无地域，其他：有地域
            cardProvince,
            cardCity,
            cardDistrict
        };
    }
    getRealTag() {
        // 针对核酸卡片，标题点击进入，需要处理tag为疫情防控写死
        const tag = decodeURIComponent(getUrlValue('tag'));
        if (this.getTitleStatus()) {
            return '疫情防控';
        }
        return tag;
    }
    // 针对核酸检测类型的卡片，标题点击进来的数据不一致，需要写死处理。
    getTitleStatus = () => {
        const tag = decodeURIComponent(getUrlValue('tag'));
        // 只有从卡片标题点击过来才有word这个参数,值为卡片query
        const word = getUrlValue('word');
        if (tag === '核酸检测机构' && word) {
            return true;
        }
        return false;
    };
    componentDidMount() {
        this.getLocation();
    }

    componentDidUpdate(prevProps: IProps) {
        if (prevProps.location.search && this.props.location.search) {
            const prevSearch = decodeURIComponent(prevProps.location.search);
            const curSearch = decodeURIComponent(this.props.location.search);
            if (prevSearch !== curSearch) {
                const {prov, city, district} = this.props.userPosition;
                const param = {
                    prov,
                    city,
                    district: district === '全部' ? '' : district,
                    page: 1
                };
                this.setState({
                    isTitleSrc: this.getTitleStatus(),
                    tag: this.getRealTag(),
                    pageSize: this.getTitleStatus() ? 50 : 10
                }, () => {
                    this.getOrganList(param);
                });
            }
        }
    }

    getLocation = () => {
        const that = this;
        const params: IAreaParam = {
            source: 'pc',
            type: '3',
            isLoc: '1',
        };
        this.setState({loading: true});

        let paramsType: AreaType;
        // @ts-ignore
        const geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(function(r: any) {
            const tempStatus = this ? this.getStatus() : null;
            // @ts-ignore
            if (tempStatus === BMAP_STATUS_SUCCESS) {
                const {province, city, district} = r.address;
                if (!r.accuracy && typeof(r.accuracy) !== 'undefined' && r.accuracy !== 0) {
                    // r.accuracy 为 null,没法获取准确定位,只用传prov、city
                    paramsType = 'need-location';
                } else {
                    params.isLoc = '0';
                    params.longitude = r.point.lng + '';
                    params.latitude = r.point.lat + '';
                    params.prov = r.address.province;
                    params.city = r.address.city;
                    params.district = r.address.district;
                    params.coordtype = 'bd09';
                    paramsType = '';

                    that.setState({isLoc: '0'});
                    that.props.setUserPosition({
                        userPosition: {
                            prov: province,
                            city,
                            district
                        }
                    });
                    that.props.setUserPoint({
                        latitude: r.point.lat + '',
                        longitude: r.point.lng + '',
                    });
                }
            } else {
                paramsType = 'need-location';
                console.log('浏览器定位 failed 状态  ' + tempStatus);
            }
            that.setState({loading: false, coordtype: 'bd09'});
            that.initArea(params, paramsType);
        });
        // }
    };
    // 切换位置确认弹窗
    showSwitchToast = (geoinfo: Omit<IPosition, 'prov'>) => {
        const {userPosition, pageType} = this.props;
        const {isFirstSwitchToast, routerSearch, srcid, tag} = this.state;
        const {prov, city, district} = userPosition;
        const that = this;
        if (!isFirstSwitchToast) {
            return;
        }
        const isProvNotSame = geoinfo.province !== prov;
        const isCityNotSame = geoinfo.city && geoinfo.city !== city;
        const isDistrictNotSame = geoinfo.district && district && geoinfo.district !== district;
        const tempLoc = prov === city ? prov : prov + city;
        if (isProvNotSame || isCityNotSame || isDistrictNotSame) {
            // 先比对省，省一样如果有市的情况就比对市
            const pointParam = {
                search: routerSearch,
                pageType,
                srcid,
                tag
            };
            recordProxy('locationSwitchToast', 'show', JSON.stringify(pointParam));
            Modal.confirm({
                title: '区域切换提示',
                content: `获取到您当前定位在${tempLoc}${district}，是否切换所在地？`,
                okText: '切换',
                cancelText: '取消',
                className: 'location-switch-toast',
                icon: <ExclamationCircleFilled style={{color: '#215FFF'}} />,
                onOk() {
                    const param = {
                        prov,
                        city,
                        district,
                        query: ''
                    };
                    recordProxy('locationSwitchClick', 'click', JSON.stringify(pointParam));
                    that.setState({routerSearch: '', page: 1});
                    that.getOrganList(param);
                },
                onCancel() {
                    that.props.setUserPosition({
                        userPosition: {
                            prov: geoinfo.province,
                            city: geoinfo.city,
                            district: geoinfo.district
                        }
                    });
                }
            });
        } else {
            that.props.setUserPosition({
                userPosition: {
                    prov: geoinfo.province,
                    city: geoinfo.city,
                    district: geoinfo.district
                }
            });
        }
        this.setState({
            isFirstSwitchToast: false,
        });
    };

    // 获取机构列表
    getOrganList(param: areaParams) {
        this.setState({loading: true});
        const {
            page, pageSize, routerSearch, isLoc, tag, coordtype, cardProvince, cardCity, cardDistrict
        } = this.state;
        const {longitude, latitude} = this.props;
        param.district = param.district === '全部' ? '' : param.district;
        const params = {
            page: page,
            size: pageSize,
            source: 'pc',
            type: '3',
            isLoc,
            longitude,
            latitude,
            coordtype,
            query: routerSearch,
            tag: tag,
            querytype: '',
            card_prov: cardProvince,
            card_city: cardCity,
            card_district: cardDistrict,
            ...param,
        };
        params.querytype = params.query ? '1' : '0';

        const _fetchLocationResult = (value: any) => {
            this.props.getLocationResult({
                ...value,
                ...params,
            }).then(res => {
                if (res && res.code === 200 ) {
                    this.setState({
                        organList: res.data.info,
                        organCount: res.data.count,
                        pageShowTitle: res.data.showTitle,
                        pageShowText: res.data.text,
                        isNoRegionType: res.data.isNotArea
                    });
                    // res.data.isNotArea: '1' (无地域类型，不需要展示地域切换)
                    res.data.geoinfo
                        && res.data.isNotArea !== '1'
                        && this.showSwitchToast(res.data.geoinfo);
                }
                this.setState({loading: false});
            });
        };
        bCat_2055_request(_fetchLocationResult);
        // todo: 请求机构列表，并返回当前title有关机构的定位，比对，如果非同城需要显示弹窗确认
    }
    initArea(params: IAreaParam, type: string) {
        const {coordtype} = this.state;
        this.setState({loading: true});
        const areaParams: areaParams = {
            coordtype,
            ...params,
        };
        const organParams = {...areaParams};
        // 获取定位信息+地域词典
        const fetchAreaData = (value: any) => {
            this.props.getAreaData({
                ...value,
                ...areaParams
            }).then(res => {
                this.setState({loading: false});
                if (res && res.code === 200 && res.data.info) {
                    this.setState({locArr: this.handleData(res.data.info) as any});
                    if (type === 'need-location') {
                        const {province, city, district} = res.data.geoinfo;
                        organParams.prov = province;
                        organParams.city = city;
                        // type为need-location时分两种情况：
                        // 一种是：使用原生定位方法拿到经纬度（但是没有省市区）需要从接口拿到省市区信息
                        // 另一种是：使用原生方法或者使用地图未拿到定位信息，只显示省市不显示区
                        organParams.district = areaParams.latitude ? district : '';
                        // organParams.district = '';
                        this.props.setUserPosition({
                            userPosition: {
                                prov: province,
                                city,
                                district: organParams.district
                            }
                        });
                    }
                    this.getOrganList(organParams);
                }
            });
        };
        bCat_2055_request(fetchAreaData);
    }
    getLoopData = (value: any) => {
        // 遍历地域字典，生成符合 ant-d组件和Cascade组件需要的数据结构
        value.children && value.children.map((p: any) => {
            p.value = p.name;
            p.label = p.name;
            this.getLoopData(p);
        });
    };
    handleData = (data: IAreaDict[]) => {
        // 针对每个省下面的市和区增加「全部」选项
        data.length > 0 && data.map((val: any) => {
            val.value = val.name;
            val.label = val.name;
            this.getLoopData(val);
        });
        return data;
    };
    onPageChange = (page: number) => {
        const {pageType, userPosition} = this.props;
        const {routerSearch, srcid, pageShowTitle, tag} = this.state;
        const {prov, city, district} = userPosition;

        const param = {
            prov,
            city,
            district
        };
        const pointParam = {
            search: routerSearch,
            pageType: pageType,
            srcid,
            curPage: page,
            title: pageShowTitle,
            tag,
        };
        recordProxy('locationPagination', 'click', JSON.stringify(pointParam));
        this.setState({
            page: page
        }, () => {
            this.getOrganList(param);
            window.scrollTo(0, 0);
        });
    };
    onPickerChange = (location: Omit<IPosition, 'province'>) => {
        const {prov, city, district} = location;
        const param = {
            prov,
            city,
            district: district === '全部' ? '' : district,
            query: ''
        };
        this.props.setUserPosition({
            userPosition: {
                prov: prov,
                city: city,
                district: district
            }
        });
        this.setState({routerSearch: '', page: 1}, () => {
            this.getOrganList(param);
        });
    };

    getHesuanUrlParam = () => {
        const {srcid, cardTitle} = this.state;
        // tag需要用真实tag
        const tag = decodeURIComponent(getUrlValue('tag'));
        const urlParam = `srcid=${srcid}&search=${cardTitle}&tag=${tag}`;
        return urlParam;
    };
    render() {
        const {
            locArr, organList, organCount, page, srcid,
            routerSearch, loading, pageShowTitle, pageShowText, isTitleSrc, tag,
            isNoRegionType
        } = this.state;
        const {userPosition, pageType, userInfo} = this.props;
        // const organData = [{name: '卡尤迪医学检验实验室-海淀清河舱'}, {name: '百世诺（北京）医学检验实验室'}];
        return (<div className="location-result">
            <div className="title-wrapper">
                <div className="title-left">
                    <div className="title">{pageShowTitle}</div>
                </div>
                {userPosition
                    && userPosition.prov
                    && locArr.length > 0
                    && pageShowTitle
                    && isNoRegionType !== '1'
                    && <CompLocationPicker
                        locArr={locArr}
                        userPosition={userPosition}
                        onPickerChange={this.onPickerChange}
                        pageType={pageType} // 页面类型
                        srcid={srcid}
                        search={routerSearch}
                        title={pageShowTitle}
                        tag={tag}
                    />}
            </div>
            <p className="tip">{pageShowText}</p>
            <Spin spinning={loading}>
                <div style={{minWidth: '996px', minHeight: '100px'}}>
                    {userPosition.prov && pageShowTitle && <CompAreaItem
                        isNoRegionType={isNoRegionType}
                        organData={organList}
                        pageType={pageType} // 页面类型
                        srcid={srcid}
                        search={routerSearch}
                        pageTitle={pageShowTitle}
                        pageTag={tag}
                    />}
                </div>
            </Spin>
            {organCount > 0 && !isTitleSrc && <Pagination
                className="location-pagination"
                showSizeChanger={false}
                onChange={this.onPageChange}
                current={page}
                total={organCount}
            />}
            {isTitleSrc
                && <CompMoreService
                    btnList={['hesuan', 'occupy', 'feedback']}
                    phoneList={[]}
                    path="location-page"
                    title={pageShowTitle}
                    tag={tag}
                    fetchUserInfo={this.props.fetchUserInfo}
                    history={this.props.history}
                    userInfo={userInfo}
                    urlParam={this.getHesuanUrlParam()}
                />
            }
        </div>);
    }
}

function mapStateToProps(state: any) {
    return {
        userPosition: state.locationPageReducer.userPosition,
        latitude: state.locationPageReducer.latitude,
        longitude: state.locationPageReducer.longitude,
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch: Function) {
    return {
        setUserPosition: (obj: any) => setUserPosition(dispatch, obj),
        setUserPoint: (obj: any) => setUserPoint(dispatch, obj),
        getAreaData: (obj: any) => getAreaData(dispatch, obj),
        getLocationResult: (obj: any) => getLocationResult(dispatch, obj),
        fetchUserInfo: () => fetchUserInfo(dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter<any, any> (LocationResult));
